import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Barber, BarberRow } from './barber';
import { ApiService } from '../api/api.service';
import { SliceQuery } from '../api/api.defs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BarbersService {

	all = new BehaviorSubject<Barber[]>([]);

	constructor(
		private _api: ApiService,
	) {	}

	fetch() {
		return this._api
			.request<SliceQuery<BarberRow>>({'$/slice/report': {
				slice: environment.slices.barbers,
				order: [['$field', 'barber']],
			}}, 'barbers.fetch')
			.pipe(
				map(resp => resp.rows.map(row => new Barber(row))),
				tap(barbers => this.all.next(barbers))
			)
	}
}
